class UAAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.speed = parseInt(this.dataset.speed) || 5;
    this.activeClass = 'active';
    this.animateOutClass = 'animate-out';
    this.activeIndex = 0;
  }

  connectedCallback() {
    this.rotateAnnouncements();
    // pause on hover
    this.addEventListener('mouseenter', () => clearInterval(this.interval));
    this.addEventListener('mouseleave', () => this.rotateAnnouncements());
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  rotateAnnouncements() {
    this.interval = setInterval(() => {
      const announcements = this.querySelectorAll('.announcement-bar__item');

      // find element with active class and remove it
      let animateOutElement = this.querySelector(`.${this.animateOutClass}`);
      let activeElement = this.querySelector(`.${this.activeClass}`);

      if (animateOutElement) {
        animateOutElement.classList.remove(this.animateOutClass);
      }

      // add animate-out class to active element and remove active class
      if (activeElement) {
        activeElement.classList.add(this.animateOutClass);
        activeElement.classList.remove(this.activeClass);
      }

      // calculate next index
      let nextIndex = (this.activeIndex + 1) % announcements.length;

      // add active class to next element
      announcements[nextIndex].classList.add(this.activeClass);

      // update activeIndex for next iteration
      this.activeIndex = nextIndex;

    }, (this.speed * 1000));
  }
}

customElements.define('announcement-bar', UAAnnouncementBar);
